<template>
  <div id="menupage">
  <div class="portrait headline1">
    Siden ses bedst i landskab!
  </div>
  <div class="landscape">
  <div class="headline1">{{ data.title }}</div>
  <div class="headline2">{{ data.tagline }}</div>
  <div class="text">
    <div id="menuline">
        <router-link :to="{ name: 'videomenu'}"><div id="video">VIDEO</div></router-link>
        <router-link :to="{ name: 'gallery'}"><div id="foto">FOTO</div></router-link>
        <router-link :to="{ name: 'kontakt'}"><div id="kontakt">KONTAKT</div></router-link>
    </div>
  </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'MainMenu',
  props: ['data'],
   mounted() {
    // document.querySelector("#fullpage").style.backgroundImage="url(https://albertusfilm.dk/drupal/sites/default/files/styles/albertusbg/public/jabaggrundsbillede1.jpg?itok=5SGMMtTa) "
    document.querySelector("#fullpage").style.backgroundImage="url(https://albertusfilm.dk/drupal/sites/default/files/styles/albertusbg/public/jabaggrundsbillede1.jpg?itok=5SGMMtTa) "
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
